(() => {
  const init = (root) => {
    if (!root || root.dataset.wwReady) return;
    root.dataset.wwReady = 'true';
    const q = (selector) => root.querySelector(selector);
    const qa = (selector) => [...root.querySelectorAll(selector)];
    const subscriptionToggle = q('.wormwood-subscription-toggle__input');
    const offerBlocks = qa('.product-selector_block[data-variant-id]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    });
    const syncOfferPrices = () => {
      const subscribed = subscriptionToggle?.checked ?? true;
      offerBlocks.forEach((block) => {
        const cents = Number(subscribed ? block.dataset.subscriptionPrice : block.dataset.oneTimePrice);
        const discount = subscribed ? block.dataset.subscriptionDiscount : block.dataset.oneTimeDiscount;
        const price = block.querySelector('.product-selector_price');
        const discountLabel = block.querySelector('.variant-discount');
        if (price && Number.isFinite(cents)) price.textContent = money.format(cents / 100);
        if (discountLabel && discount) discountLabel.textContent = `${discount}% Discount`;
      });
    };
    const chooseKachingPurchaseOption = () => {
      if (!subscriptionToggle) return false;
      const cards = qa('.kaching-subscriptions__card-wrapper');
      if (!cards.length) return false;
      const target = cards.find((card) => (
        subscriptionToggle.checked
          ? !card.classList.contains('one-time-purchase')
          : card.classList.contains('one-time-purchase')
      ));
      if (target && !target.classList.contains('selected')) target.click();
      return Boolean(target);
    };
    if (subscriptionToggle) {
      const syncSubscription = () => {
        syncOfferPrices();
        chooseKachingPurchaseOption();
      };
      subscriptionToggle.addEventListener('change', syncSubscription);
      syncOfferPrices();
      if (!chooseKachingPurchaseOption()) {
        const observer = new MutationObserver(() => {
          if (chooseKachingPurchaseOption()) observer.disconnect();
        });
        observer.observe(root, { childList: true, subtree: true });
        window.setTimeout(() => observer.disconnect(), 10000);
      }
    }
    const thumbs = qa('#productThumbs .gallery-item');
    const main = q('#mainPackImage');
    const brandedGallery = q('.wormwood-branded-gallery');
    if (brandedGallery) {
      const sources = JSON.parse(brandedGallery.textContent);
      const setImage = (image, url) => {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
      };
      sources.forEach((url, index) => {
        const thumb = thumbs[index];
        if (thumb) {
          thumb.dataset.imageSrc = url;
          setImage(thumb.querySelector('img'), url);
        }
        setImage(qa('.main_product-image-carousel .main_product-image-box img')[index], url);
      });
      setImage(main, sources[0]);
    }
    let galleryIndex = 0;
    const showGallery = (index) => {
      if (!thumbs.length) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      thumbs.forEach((button, i) => button.classList.toggle('is-active', i === galleryIndex));
      if (main) {
        const src = thumbs[galleryIndex].dataset.imageSrc || thumbs[galleryIndex].querySelector('img')?.src;
        if (src) main.src = src;
      }
      qa('.main_product-image-carousel .main_product-image-box').forEach((slide, i) => slide.classList.toggle('is-active', i === galleryIndex));
    };
    thumbs.forEach((button, i) => button.addEventListener('click', () => showGallery(i)));
    q('.main_nav--prev')?.addEventListener('click', () => showGallery(galleryIndex - 1));
    q('.main_nav--next')?.addEventListener('click', () => showGallery(galleryIndex + 1));
    qa('.product-selector_block[data-variant-id]').forEach((button) => {
      const selectVariant = () => {
        qa('.product-selector_block[data-variant-id]').forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        const input = q('.product-variant-id');
        if (input) {
          input.value = button.dataset.variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        window.setTimeout(chooseKachingPurchaseOption, 0);
      };
      button.addEventListener('click', selectVariant);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectVariant();
        }
      });
    });
    qa('.product_tab-thumb').forEach((button) => button.addEventListener('click', () => button.closest('.product_tab-block')?.classList.toggle('is-open')));
    qa('.product_faq-thumb').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.product_faq-box');
        const wasOpen = item?.classList.contains('is-open');
        qa('.product_faq-box').forEach((box) => box.classList.remove('is-open'));
        if (item && !wasOpen) item.classList.add('is-open');
      });
    });
    const initCarousel = (selector, dotSelector, slideSelector, trackSelector) => {
      qa(selector).forEach((carousel) => {
        const dots = [...carousel.querySelectorAll(dotSelector)];
        const slides = [...carousel.querySelectorAll(slideSelector)];
        const track = carousel.querySelector(trackSelector);
        let index = Math.max(0, dots.findIndex((dot) => dot.classList.contains('is-active')));
        const show = (next) => {
          if (!slides.length) return;
          index = (next + slides.length) % slides.length;
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
          if (track) track.style.transform = `translateX(-${index * 100}%)`;
        };
        dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
        carousel.querySelector('[class*="prev"]')?.addEventListener('click', () => show(index - 1));
        carousel.querySelector('[class*="next"]')?.addEventListener('click', () => show(index + 1));
        show(index);
      });
    };
    const initMediaCarousel = (carousel) => {
      if (!carousel || carousel.dataset.wwMediaReady) return;
      carousel.dataset.wwMediaReady = 'true';

      const track = carousel.querySelector('.mc2-track');
      const slides = [...carousel.querySelectorAll('.mc2-slide')];
      const dotsWrap = carousel.querySelector('.mc2-dots');
      const prev = carousel.querySelector('.mc2-btn--prev');
      const next = carousel.querySelector('.mc2-btn--next');
      const viewport = carousel.querySelector('.mc2-viewport');
      if (!track || !slides.length || !dotsWrap || !viewport) return;

      let current = 0;
      let autoplayTimer;
      let resumeTimer;
      let resizeTimer;
      let touchStartX = 0;
      let isTouching = false;
      const autoplayMs = 4000;
      const slidesPerView = () => (window.innerWidth <= 768 ? 1 : 3);
      const maxIndex = () => Math.max(0, slides.length - slidesPerView());

      const setSizes = () => {
        const width = viewport.clientWidth / slidesPerView();
        slides.forEach((slide) => { slide.style.width = `${width}px`; });
      };

      const applyTranslate = () => {
        const width = viewport.clientWidth / slidesPerView();
        track.style.transform = `translateX(-${current * width}px)`;
      };

      const updateDots = () => {
        [...dotsWrap.querySelectorAll('.mc2-dot')].forEach((dot, i) => {
          dot.classList.toggle('is-active', i === current);
        });
      };

      const goTo = (index) => {
        if (index < 0) index = maxIndex();
        if (index > maxIndex()) index = 0;
        current = index;
        applyTranslate();
        updateDots();
      };

      const stopAutoplay = () => {
        if (autoplayTimer) window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };

      const startAutoplay = () => {
        stopAutoplay();
        autoplayTimer = window.setInterval(() => {
          if (!carousel.isConnected) return stopAutoplay();
          if (!isTouching) goTo(current + 1);
        }, autoplayMs);
      };

      const scheduleResume = () => {
        window.clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          if (!isTouching) startAutoplay();
        }, 1200);
      };

      const buildDots = () => {
        dotsWrap.replaceChildren();
        for (let i = 0; i <= maxIndex(); i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `mc2-dot${i === current ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Slide ${i + 1}`);
          dot.addEventListener('click', () => {
            stopAutoplay();
            goTo(i);
            scheduleResume();
          });
          dotsWrap.appendChild(dot);
        }
      };

      prev?.addEventListener('click', () => {
        stopAutoplay();
        goTo(current - 1);
        scheduleResume();
      });
      next?.addEventListener('click', () => {
        stopAutoplay();
        goTo(current + 1);
        scheduleResume();
      });

      track.addEventListener('touchstart', (event) => {
        isTouching = true;
        stopAutoplay();
        touchStartX = event.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', (event) => {
        const difference = touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(difference) > 50) goTo(difference > 0 ? current + 1 : current - 1);
        isTouching = false;
        scheduleResume();
      }, { passive: true });

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          current = Math.min(current, maxIndex());
          setSizes();
          applyTranslate();
          buildDots();
        }, 120);
      });

      setSizes();
      applyTranslate();
      buildDots();
      startAutoplay();
    };

    qa('[id^="media-carousel-"]').forEach(initMediaCarousel);
    const initTestimonialCarousel = (carousel) => {
      if (!carousel || carousel.dataset.wwTestimonialReady) return;
      carousel.dataset.wwTestimonialReady = 'true';

      const slides = [...carousel.querySelectorAll('.ct-carousel__slide')];
      const dots = [...carousel.querySelectorAll('.ct-carousel__dot')];
      const swipeArea = carousel.querySelector('.ct-carousel__slides');
      if (!slides.length) return;

      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      let touchStartX = 0;

      const goTo = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      };

      const startAuto = () => {
        window.clearInterval(timer);
        if (slides.length > 1) {
          timer = window.setInterval(() => {
            if (!carousel.isConnected) return window.clearInterval(timer);
            goTo(current + 1);
          }, 5000);
        }
      };

      carousel.querySelectorAll('.ct-carousel__arrow--prev').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          goTo(current - 1);
          startAuto();
        });
      });
      carousel.querySelectorAll('.ct-carousel__arrow--next').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          goTo(current + 1);
          startAuto();
        });
      });
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          goTo(i);
          startAuto();
        });
      });

      swipeArea?.addEventListener('touchstart', (event) => {
        window.clearInterval(timer);
        touchStartX = event.touches[0].clientX;
      }, { passive: true });
      swipeArea?.addEventListener('touchend', (event) => {
        const difference = touchStartX - event.changedTouches[0].clientX;
        if (Math.abs(difference) > 50) goTo(difference > 0 ? current + 1 : current - 1);
        startAuto();
      }, { passive: true });

      goTo(current);
      startAuto();
    };

    qa('.ct-carousel').forEach(initTestimonialCarousel);
  };
  document.querySelectorAll('.wormwood-pdp').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.wormwood-pdp').forEach(init));
})();
